/* Renis Wollshop — PDP: variant selection (colour swatches / option pills), quantity stepper,
   gallery thumbnails, zoom + ask-question <dialog>s. Ported from shop-screens.jsx PDP.
   Native <dialog> is used for zoom/ask-question — free focus trap + Escape-to-close + backdrop. */
(function () {
  'use strict';

  document.querySelectorAll('[data-product-page]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var maxQtyEl = root.querySelector('[data-variant-max-qty]');
    var maxQtyByVariant = maxQtyEl ? JSON.parse(maxQtyEl.textContent) : {};
    var form = root.querySelector('#product-form');
    var variantIdInput = root.querySelector('[data-pdp-variant-id]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var availabilityEl = root.querySelector('[data-pdp-availability]');
    var colorLabel = root.querySelector('[data-pdp-color-label]');
    var mainImage = root.querySelector('[data-pdp-main-image]');
    var submitBtn = root.querySelector('[data-pdp-submit]');
    var selected = {};
    var defaultVariantId = parseInt(variantIdInput.value, 10);
    var currentMaxQty = maxQtyByVariant[defaultVariantId];

    function applyQtyCap() {
      var valEl = root.querySelector('[data-qty-value]');
      var input = root.querySelector('[data-pdp-qty-input]');
      var incrBtn = root.querySelector('[data-pdp-qty] [data-qty-increase]');
      if (!valEl) return;
      var current = parseInt(valEl.textContent, 10);
      if (typeof currentMaxQty === 'number' && current > currentMaxQty) {
        current = Math.max(1, currentMaxQty);
        valEl.textContent = current;
        if (input) input.value = current;
      }
      if (incrBtn) incrBtn.disabled = typeof currentMaxQty === 'number' && current >= currentMaxQty;
    }

    product.variants.forEach(function (v) {
      if (v.id === defaultVariantId) {
        v.options.forEach(function (val, i) { selected[i] = val; });
      }
    });

    function findVariant() {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return selected[i] === undefined || selected[i] === val; });
      });
    }

    // clicking the already-selected swatch/option again resets to the variant the page
    // originally loaded with, since otherwise there's no way back to it once ?variant= is
    // in the URL — every other option stays clickable, this is just an "undo" on that one
    function resetToDefault() {
      var defaultVariant = product.variants.find(function (v) { return v.id === defaultVariantId; });
      if (!defaultVariant) return;
      selected = {};
      defaultVariant.options.forEach(function (val, i) { selected[i] = val; });
      render(defaultVariant, false);
      var url = new URL(window.location.href);
      url.searchParams.delete('variant');
      window.history.replaceState({}, '', url);
    }

    function money(cents) {
      return 'CHF ' + (cents / 100).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function render(variant, highlightSwatch) {
      if (!variant) return;
      if (highlightSwatch === undefined) highlightSwatch = true;
      variantIdInput.value = variant.id;
      if (priceEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceEl.innerHTML =
          '<span class="rw-price rw-price--lg' + (onSale ? ' rw-price--sale' : '') + '">' +
          '<span class="rw-price__amount">' + money(variant.price) + '</span>' +
          (onSale ? '<span class="rw-price__original">' + money(variant.compare_at_price) + '</span>' : '') +
          '</span>';
      }
      if (availabilityEl) {
        availabilityEl.style.color = variant.available ? 'var(--text-positive-default)' : 'var(--text-default-secondary)';
        availabilityEl.querySelector('span') && (availabilityEl.querySelector('span').textContent = '');
      }
      if (colorLabel) colorLabel.textContent = variant.title;
      if (mainImage && variant.featured_image) {
        var matchingSwatch = root.querySelector('[data-pdp-swatch][data-variant-id="' + variant.id + '"]');
        if (matchingSwatch && matchingSwatch.dataset.largeImage) mainImage.src = matchingSwatch.dataset.largeImage;
      }
      root.querySelectorAll('[data-pdp-swatch]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(highlightSwatch && parseInt(btn.dataset.variantId, 10) === variant.id));
      });
      root.querySelectorAll('[data-pdp-option]').forEach(function (btn) {
        var idx = btn.dataset.optionIndex;
        btn.setAttribute('aria-pressed', String(selected[idx] === btn.dataset.value));
      });
      if (submitBtn) submitBtn.disabled = !variant.available;
      currentMaxQty = maxQtyByVariant[variant.id];
      applyQtyCap();
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    applyQtyCap();

    root.addEventListener('click', function (e) {
      var swatch = e.target.closest('[data-pdp-swatch]');
      if (swatch) {
        if (selected[swatch.dataset.optionIndex] === swatch.dataset.value) {
          resetToDefault();
          return;
        }
        selected[swatch.dataset.optionIndex] = swatch.dataset.value;
        render(findVariant());
        return;
      }
      var opt = e.target.closest('[data-pdp-option]');
      if (opt) {
        if (selected[opt.dataset.optionIndex] === opt.dataset.value) {
          resetToDefault();
          return;
        }
        selected[opt.dataset.optionIndex] = opt.dataset.value;
        render(findVariant());
        return;
      }
      var thumb = e.target.closest('[data-pdp-thumb]');
      if (thumb && mainImage) {
        if (thumb.dataset.largeImage) mainImage.src = thumb.dataset.largeImage;
        return;
      }
      var qtyIncr = e.target.closest('[data-pdp-qty] [data-qty-increase]');
      if (qtyIncr) {
        var valEl = root.querySelector('[data-qty-value]');
        var input = root.querySelector('[data-pdp-qty-input]');
        var next = parseInt(valEl.textContent, 10) + 1;
        if (typeof currentMaxQty === 'number' && next > currentMaxQty) return;
        valEl.textContent = next; input.value = next;
        applyQtyCap();
        return;
      }
      var qtyDecr = e.target.closest('[data-pdp-qty] [data-qty-decrease]');
      if (qtyDecr) {
        var valEl2 = root.querySelector('[data-qty-value]');
        var input2 = root.querySelector('[data-pdp-qty-input]');
        var next2 = Math.max(1, parseInt(valEl2.textContent, 10) - 1);
        valEl2.textContent = next2; input2.value = next2;
        applyQtyCap();
        return;
      }
    });
  });

  // zoom dialog
  document.addEventListener('click', function (e) {
    var openZoom = e.target.closest('[data-pdp-zoom-open]');
    if (openZoom) {
      var dialog = document.getElementById('rw-pdp-zoom');
      var src = openZoom.querySelector('img');
      if (dialog && src) {
        dialog.querySelector('[data-pdp-zoom-image]').src = src.src;
        dialog.showModal();
      }
      return;
    }
    if (e.target.closest('[data-pdp-zoom-close]')) { document.getElementById('rw-pdp-zoom').close(); return; }

    var openAsk = e.target.closest('[data-ask-question-open]');
    if (openAsk) { document.getElementById('rw-ask-question').showModal(); return; }
    if (e.target.closest('[data-ask-question-close]')) { document.getElementById('rw-ask-question').close(); return; }
  });

  // click on <dialog> backdrop closes it
  document.querySelectorAll('dialog').forEach(function (dialog) {
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  });
})();
